
export default function Services() {
  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              事業内容
            </h2>
            <div className="flex items-center justify-center gap-2">
              <div className="w-12 h-0.5 bg-amber-500"></div>
              <div className="w-2 h-2 bg-amber-500 rotate-45"></div>
              <div className="w-12 h-0.5 bg-amber-500"></div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 p-8 border-l-4 border-amber-500 hover:scale-105">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center flex-shrink-0 shadow-lg">
                  <i className="ri-global-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                    インターネットを利用した情報提供サービス
                  </h3>
                  <p className="text-gray-600 leading-relaxed" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    オンラインプラットフォームを活用し、最新のビジネス情報や市場動向を提供します。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 p-8 border-l-4 border-amber-500 hover:scale-105">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center flex-shrink-0 shadow-lg">
                  <i className="ri-file-list-3-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                    各種事務処理の代行業務（業務サポート）
                  </h3>
                  <p className="text-gray-600 leading-relaxed" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    煩雑な事務作業を代行し、お客様の本業に集中できる環境を提供します。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 p-8 border-l-4 border-amber-500 hover:scale-105">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center flex-shrink-0 shadow-lg">
                  <i className="ri-window-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                    ウェブサイト・クラウドシステムの企画・運営
                  </h3>
                  <p className="text-gray-600 leading-relaxed" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    効果的なウェブサイトとクラウドシステムの構築から運営まで、トータルサポートします。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 p-8 border-l-4 border-amber-500 hover:scale-105">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center flex-shrink-0 shadow-lg">
                  <i className="ri-line-chart-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                    経営・業務コンサルティング
                  </h3>
                  <p className="text-gray-600 leading-relaxed" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    経営課題の解決から業務改善まで、専門的な知見でサポートします。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 p-8 border-l-4 border-amber-500 hover:scale-105 md:col-span-2">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center flex-shrink-0 shadow-lg">
                  <i className="ri-image-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                    デジタルコンテンツの企画・制作・販売
                  </h3>
                  <p className="text-gray-600 leading-relaxed" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    高品質なデジタルコンテンツの企画から制作、販売まで一貫して対応します。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
